import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApiService } from '../services/api.service';
import { AuthService } from '../services/auth.service';
import { ToasterService } from '../services/toaster.service';

export const mobileRouteGuard: CanActivateFn = (route, state) => {
  if (route.data?.['blockOnMobile'] !== true) {
    return true;
  }

  const apiService = inject(ApiService);
  const authService = inject(AuthService);
  const router = inject(Router);
  const toasterService = inject(ToasterService);

  if (!apiService.syncMobileDeviceState()) {
    return true;
  }

  const redirectPath = authService.getActiveAccount() ? '/projects' : '/welcome';
  toasterService.error('This page is not available on mobile. Redirected to a home page.');
  router.navigate([redirectPath]);
  return false;
};
